import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';

class ValidationPeriodSettingsComponentCtrl implements ng.IController {
    settings: TsoSecondarySettingsDto;
    authenticatedUser: LoginResult;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private $q: ng.IQService
    ) {}

    $onInit() {}

    saveTransferOfUse(): ng.IPromise<any> {
        if (
            !this.validateWholeNumber(
                this.settings.tradeValidationPeriodConfigTransferOfUse.value
            )
        ) {
            return this.$q.reject();
        }

        return this.TransmissionSystemOperator.saveValidationPeriod(
            {
                id: this.authenticatedUser.referenceId,
                transactionType: <ProposalTransactionType>'TRANSFER_OF_USE'
            },
            this.settings.tradeValidationPeriodConfigTransferOfUse
        ).$promise;
    }

    saveAssignment(): ng.IPromise<any> {
        if (
            !this.validateWholeNumber(
                this.settings.tradeValidationPeriodConfigAssignment.value
            )
        ) {
            return this.$q.reject();
        }

        return this.TransmissionSystemOperator.saveValidationPeriod(
            {
                id: this.authenticatedUser.referenceId,
                transactionType: <ProposalTransactionType>'ASSIGNMENT'
            },
            this.settings.tradeValidationPeriodConfigAssignment
        ).$promise;
    }

    private validateWholeNumber(value: number): boolean {
        if (value % 1 !== 0) {
            this.growl.show('Only whole numbers permitted.', 'danger', {
                delay: 5000
            });
            return false;
        }
        return true;
    }
}

angular.module('app').component('pkpValidationPeriodSettings', {
    controller: ValidationPeriodSettingsComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/validation-period-settings.component.html'),
    bindings: {
        settings: '=',
        authenticatedUser: '='
    }
});
